import React, { useEffect } from "react";
import styled from "styled-components";
import ThumbUpAltOutlined from "@material-ui/icons/ThumbUpAltOutlined";
import InsertEmoticonOutlined from "@material-ui/icons/InsertEmoticonOutlined";
import diamond from "../../assets/home/diamond.svg";
import AOS from "aos";
import { frontEnd } from "../../config/links";
import { useHistory } from "react-router-dom";

const ExamPrep = () => {
  const history = useHistory();

  useEffect(() => {
    // Initialize AOS with settings to only animate once
    AOS.init({
      once: true, // This is the key setting - animations will only happen once
      mirror: false, // Don't mirror animations when scrolling back up
      duration: 800,
      offset: 100, // Controls when the animation triggers
      easing: "ease-out"
    });

    // Refresh AOS on component mount
    AOS.refresh();
  }, []);

  const handleTryForFreeClick = () => {
    // Similar to handleLoginClick, show the auth modal and navigate to login
    // setShowAuthModal(true);
    history.push(frontEnd.register);
  };

  return (
    <Container>
      <StyledImage
        src="/assets/home/lamp.png"
        alt="lamp"
        position="top-left"
        data-aos="fade-down-right"
        data-aos-duration="600"
      />
      <StyledImage
        src="/assets/home/circle.png"
        alt="circle"
        position="top-right"
        data-aos="fade-down-left"
        data-aos-duration="500"
      />
      <StyledImage
        src="/assets/home/vector2.png"
        alt="vector2"
        position="bottom-right"
        data-aos="fade-up-left"
        data-aos-duration="500"
      />
      <ContentWrapper data-aos="fade-up" data-aos-duration="500">
        <MainText>
          <BrandText>GetThru</BrandText> is your ultimate resource{" "}
          <StyledDiamond src={diamond} alt="diamond" /> for medical exam
          preparation. Whether you're studying for the{" "}
          <ItalicText>GSSE, BPS, or other medical exams</ItalicText>, our
          platform offers a vast library of questions, detailed explanations,
          and personalized study tools to help you succeed{" "}
          <StyledEmoticon1>
            <InsertEmoticonOutlined
              style={{
                color: "#4CAF50",
                width: "40px",
                height: "20px",
                transform: "translateY(8px)"
              }}
            />
          </StyledEmoticon1>
          <StyledEmoticon2>
            <InsertEmoticonOutlined
              style={{
                color: "#4CAF50",
                width: "19px",
                height: "19px",
                transform: "translateY(5px)"
              }}
            />
          </StyledEmoticon2>
        </MainText>

        <SignUpSection
        // data-aos="fade-up"
        // data-aos-delay="100"
        // data-aos-duration="400"
        >
          <StyledThumbUp />
          <SignUpLink onClick={() => handleTryForFreeClick()}>
            Sign up
          </SignUpLink>
          <StyledSpan1>now and gain access to thousands of</StyledSpan1>
          <StyledSpan2>now and gain</StyledSpan2>
        </SignUpSection>
        <StyledSpan3
        // data-aos="fade-up"
        // data-aos-delay="150"
        // data-aos-duration="400"
        >
          access to thousands of
        </StyledSpan3>
        <SignUpSection
        // data-aos="fade-up"
        // data-aos-delay="150"
        // data-aos-duration="400"
        >
          questions tailored to your exam.
        </SignUpSection>
        <SignUpSection1>
          <StyledThumbUp />
          <SignUpLink onClick={() => handleTryForFreeClick()}>
            Sign up
          </SignUpLink>
          <StyledSpan4>
            now and gain access to thousands of questions tailored to your exam.
          </StyledSpan4>
        </SignUpSection1>
      </ContentWrapper>
    </Container>
  );
};

const Container = styled.div`
  background-image: url("/assets/home/home-hero-bg.png");
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
  padding: 117px 245px;
  border-radius: 20px;
  width: 100%;
  max-width: 1440px;
  margin: 32px auto;
  position: relative;
  overflow: hidden;

  @media (max-width: 768px) {
    padding: 24px;
    margin: 16px;
    width: auto;
  }

  @media (max-width: 1472px) {
    margin: 16px;
    width: auto;
  }
`;

const ContentWrapper = styled.div`
  position: relative;
  z-index: 1;
`;

const MainText = styled.div`
  font-size: 38px;
  font-weight: 600;
  line-height: 1.6;
  margin-bottom: 24px;
  color: #333;

  @media (max-width: 768px) {
    font-size: 16px;
  }
`;

const BrandText = styled.span`
  font-size: 16px;
  background-color: #fff5ac;
  padding: 0 10px;
  transform: rotate(-1deg);
  display: inline-block;
  @media (min-width: 768px) {
    font-size: 38px;
  }
`;

const ItalicText = styled.span`
  font-style: italic;
  font-weight: 800;
`;

const StyledDiamond = styled.img`
  vertical-align: middle;
  margin: 0 3px;
  width: 24px;
  height: 24px;
  @media (min-width: 768px) {
    width: 40px;
    height: 40px;
  }
`;

const StyledEmoticon1 = styled.span`
  display: none;
  @media (min-width: 768px) {
    display: inline;
  }
`;

const StyledEmoticon2 = styled.span`
  display: inline;
  @media (min-width: 768px) {
    display: none;
  }
`;

const StyledThumbUp = styled(ThumbUpAltOutlined)`
  color: #333;
`;

const SignUpSection = styled.div`
  display: flex;
  gap: 8px;
  font-size: 38px;
  font-weight: 600;

  @media (max-width: 1365px) {
    display: none;
  }

  @media (max-width: 768px) {
    font-size: 15px;
    display: flex;
  }
`;

const SignUpSection1 = styled.div`
  display: none;
  font-size: 38px;
  font-weight: 600;

  @media (max-width: 1365px) {
    display: block;
  }

  @media (max-width: 768px) {
    font-size: 15px;
    display: none;
  }
`;

const StyledSpan4 = styled.span`
  display: none;

  @media (max-width: 1365px) {
    display: block;
  }

  @media (max-width: 768px) {
    font-size: 15px;
    display: none;
  }
`;

const SignUpLink = styled.button`
  color: #5d7bf7;
  text-decoration: none;
  font-weight: bold;
  white-space: nowrap;
  display: inline;

  &:hover {
    text-decoration: underline;
  }
`;

const StyledSpan1 = styled.span`
  display: none;
  @media (min-width: 768px) {
    display: inline;
  }
`;

const StyledSpan2 = styled.span`
  font-size: 15px;
  display: inline;
  @media (min-width: 768px) {
    display: none;
  }
`;

const StyledSpan3 = styled.span`
  font-size: 15px;
  display: inline;
  font-weight: 600;
  @media (min-width: 768px) {
    display: none;
  }
`;

const StyledImage = styled.img<{
  position: "top-left" | "top-right" | "bottom-right";
}>`
  position: absolute;
  ${({ position }) => {
    switch (position) {
      case "top-left":
        return `
          top: 70px;
          left: 80px;
          width: 116px;
          height: 100px;
          display: none;

          @media (min-width: 968px) {
            display: block;
          }
          `;
      case "top-right":
        return `
            top: 40px;
            right: 10px;
            width: 20px;
            height: 20px;
            
            @media (min-width: 968px) {
              width: 40px;
              height: 34px;
              top: 40px;
              right: 280px;
            }
        `;
      case "bottom-right":
        return `
          bottom: 10px;
          right: 10px;
          width: 75px;
          height: 40px;
          
          @media (min-width: 968px) {
            bottom: 70px;
            right: 70px;
            width: 129px;
            height: 69px;
          }
        `;
    }
  }}
`;

export default ExamPrep;
